'use client'

import { ConfirmationForm } from '../Confirmation/Form'

import { Card, CardHeader, CardTitle, CardBody } from '@/shared/ui/Card'

export function ConfirmationPage() {
  return (
    <Card className="max-w-md">
      <CardHeader>
        <CardTitle>Confirmação de Conta</CardTitle>
      </CardHeader>
      <CardBody className="text-dark">
        <ConfirmationForm />
      </CardBody>
    </Card>
  )
}
